import {BrowserRouter as Router, Route, Routes, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";

import PageLayout from "./components/PageLayout";
import Loader from "./components/Loader";

import ScrollToHashElement from "./ScrollToHashElement";

// Страницы/секции
import ScreenFirst from "./components/ScreenFirst";
import ScreenSecond from "./components/ScreenSecond";
import ScreenThree from "./components/ScreenThree";
import KeyBusinessSegments from "./components/KeyBusinessSegments";
import WhyChooseUs from "./components/WhyChooseUs";
import InnovationSection from "./components/InnovationSection";
import SolutionsSection from "./components/SolutionsSection";
import CountriesSection from "./components/CountriesSection";
import ContactFormSection from "./components/ContactFormSection";
import NewsSection from "components/News/NewsSection";
import News from "./components/News";
import NewsArticle from "./components/News/NewsArticle";
import Privacy from "./components/Privacy";
import Disclaimer from "./components/Disclaimer";
import Principles from "./components/Principles";
import LeadershipSection from "./components/LeadershipSection";
import {trackPageView} from "./lib/metrika";

function MetrikaPageTracker() {
    const location = useLocation();

    useEffect(() => {
        trackPageView(`${location.pathname}${location.search}${location.hash}`);
    }, [location.pathname, location.search, location.hash]);

    return null;
}


function HomePage() {
    return (
        <PageLayout>
            <ScreenFirst/>
            <ScreenSecond/>
            <ScreenThree/>
            <KeyBusinessSegments/>
            <NewsSection/>
            <WhyChooseUs/>
            <InnovationSection/>
            <SolutionsSection/>
            <CountriesSection/>
            <LeadershipSection/>
            <ContactFormSection/>
        </PageLayout>
    );
}

function PrivacyPage() {
    return (
        <PageLayout>
            <Privacy/>
        </PageLayout>
    );
}

function DisclaimerPage() {
    return (
        <PageLayout>
            <Disclaimer/>
        </PageLayout>
    );
}

function PrinciplesPage() {
    return (
        <PageLayout>
            <Principles/>
        </PageLayout>
    );
}

function NewsPage() {
    return (
        <PageLayout>
            <News/>
        </PageLayout>
    );
}

function NewsArticlePage() {
    return (
        <PageLayout>
            <NewsArticle/>
        </PageLayout>
    );
}

function App() {
    const [loading, setLoading] = useState(false);

    if (loading) return <Loader/>;

    return (
        <Router>
            <ScrollToHashElement offset={50}/>
            <MetrikaPageTracker/>
            <Routes>
                <Route path="/" element={<HomePage/>}/>
                <Route path="/privacy" element={<PrivacyPage/>}/>
                <Route path="/principles" element={<PrinciplesPage/>}/>
                <Route path="/disclaimer" element={<DisclaimerPage/>}/>
                <Route path="/news" element={<NewsPage/>}/>
                <Route path="/news/:slug" element={<NewsArticlePage/>}/>
            </Routes>
        </Router>
    );
}

export default App;
